export const EquipmentController = {
    show(): void {},
};
